// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';
import {
    Address,
}                               from 'shippo';

// ===== Interfaces =====

import {
    IShippoAddressObject,
}                               from '../interfaces';

const shippoAddressValidation = async (
    {
        test,
        address,
    }: {
        test: boolean,
        address: IShippoAddressObject,
    },
): Promise<Address | null> => {
    const functions = getFunctions();
    const validator = httpsCallable<
        {
            test: boolean,
            address: IShippoAddressObject,
        },
        Address | null
    >(
        functions,
        'shippoAddressValidation',
    );

    return validator({
        test,
        address,
    }).then((result) => {
        const validatedAddress = result.data as Address | null;
        return validatedAddress;
    }).catch((err) => {
        throw err;
    });
};

export default shippoAddressValidation;
